import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalConfirmExit } from "./ModalConfirmExit";

export const useModalConfirmExit = () =>
  useWSModal(ModalConfirmExit, {
    title: "Exit document upload?",
    size: "S"
  });
